import React from 'react';
import Layout from 'components/layout';
import SubIntroBlocks from 'components/pages/Solution/Marketing/SubIntroBlocks';
import ExplanationsBlock from 'components/pages/Solution/Marketing/ExplanationsBlock/ExplanationsBlock';
import EmotionsBlock from 'components/pages/Solution/Marketing/EmotionsBlock/EmotionsBlocks';
import SliderBlock from 'components/pages/Solution/Marketing/SliderBlock/SliderBlock';
import TestimonialBlock from 'components/pages/Solution/Marketing/TestimonialBlock/TestimonialBlock';
import OperationBlocks from 'components/pages/Index/Operation/OperationBlocks';
import { Grid } from '@material-ui/core';
import { breakpoint } from 'utils/mediaQueries';
import styled from 'styled-components';
import LinkBlocks from 'components/LinkBlock/LinkBlocks';
import LinkBlockBackground from 'components/pages/Solution/Marketing/LinkBlockBackground';
import OperationBlockBackground from 'components/pages/Solution/Marketing/OperationBlockBackground';

const LinkGrid = styled(Grid)`
  position: relative;
  padding-top: 10rem;
  padding-bottom: 4rem;
  background-position: top;
  margin-top: -10rem;
  ${breakpoint.down('lg')`
  padding-top: 4rem;padding-bottom: 2rem;`}
  ${breakpoint.down('md')`
  padding-bottom: 4rem;`}
  ${breakpoint.down(
    'sm'
  )`padding-top:0;padding-bottom: 6rem; margin-top: -8rem`};
`;
const OperationGrid = styled(Grid)`
  position: relative;
  padding-top: 4rem;
  padding-bottom: 0;
  ${breakpoint.down('lg')`
  padding-top: 4rem;padding-bottom: 2rem;`}
  ${breakpoint.down(
    'md'
  )`margin-top:-6rem;padding-top:9rem;padding-bottom: 2rem;`}
  ${breakpoint.down('sm')`
   padding-top:6rem;margin-top:-3rem`};
`;
const SolutionPage = props => {
  const subintroBlocksData = {
    markdownContent: props.data.dataBlockSubintroTitle,
    body: props.data.dataBlockSubintroBody,
    images: props.data.imageSubintroBlock.nodes,
    imgObjectives: props.data.imageObjectives.nodes,
    markdownObjectives: props.data.dataObjectives.nodes,
  };
  const explanationBlockdata = {
    image: props.data.imageExplanationsBlock,
    subtitle: props.data.dataExplanationsBlockSubtitle,
    title: props.data.dataExplanationsBlockTitle,
    content: props.data.dataExplanationsBlockContent,
  };
  const emotionsBlockdata = {
    images: props.data.imageEmotionsBlock.nodes,
    title: props.data.dataBlockEmotionsTitle,
  };
  const operationBlocksData = {
    title: props.data.dataBlockOperationTitle,
    markdownContent: props.data.dataBlockOperationBody.nodes,
    images: props.data.imageOperationBlock.nodes,
  };
  const sliderBlocksData = {
    title: props.data.dataBlockSliderTitle,
    markdownContent: props.data.dataBlockSliderBody.nodes,
    images: props.data.imageSliderBlock.nodes,
  };
  const testimonialBlockData = {
    markdownContent: props.data.dataTestimonialBlock.nodes,
    images: props.data.imageTestimonialBlock.nodes,
    imagesSliderQuotes:
      props.data.imagesQuotesTestimonialBlock &&
      props.data.imagesQuotesTestimonialBlock.nodes,
  };
  const linkBlocksData = {
    markdownContent: props.data.dataBlockLinkBody,
  };
  return (
    <Layout location={props.location} seo={props.seo}>
      <SubIntroBlocks
        data={subintroBlocksData}
        lang={props.pageContext.langKey}
      />
      <ExplanationsBlock
        data={explanationBlockdata}
        lang={props.pageContext.langKey}
      />
      <SliderBlock data={sliderBlocksData} />
      <OperationGrid>
        <OperationBlocks
          data={operationBlocksData}
          lang={props.pageContext.langKey}
        />
        <OperationBlockBackground />
      </OperationGrid>
      <EmotionsBlock data={emotionsBlockdata} />
      <TestimonialBlock
        data={testimonialBlockData}
        lang={props.pageContext.langKey}
      />
      <LinkGrid>
        <LinkBlocks
          data={linkBlocksData.markdownContent.nodes}
          lang={props.pageContext.langKey}
        />
        <LinkBlockBackground />
      </LinkGrid>
      {props.children}
    </Layout>
  );
};

export default SolutionPage;
